import { gql } from "graphql-tag";

export const playTournamentGQL = gql`
  mutation PlayTournament($playTournamentInput: PlayTournamentInput) {
    playTournament(playTournamentInput: $playTournamentInput) {
      wallets {
        coinType
        balance
      }
    }
  }
`;

export const enterTournamentGQL = gql`
  mutation EnterTournament($enterTournamentInput: EnterTournamentInput) {
    enterTournament(enterTournamentInput: $enterTournamentInput) {
      edgeNodeId
      gameSessionId
      tournamentPlayerId
      updatedWallets {
        coinType
        balance
      }
    }
  }
`;
